import { render } from "./ScoringDocuments.vue?vue&type=template&id=a4f55e56"
import script from "./ScoringDocuments.vue?vue&type=script&lang=js"
export * from "./ScoringDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__